module.exports = __webpack_public_path__ + "img/photos/slider-03.jpg";